import { render, staticRenderFns } from "./leifeng_health_suggestion.vue?vue&type=template&id=e8c1ddb4&scoped=true&"
import script from "./leifeng_health_suggestion.vue?vue&type=script&lang=js&"
export * from "./leifeng_health_suggestion.vue?vue&type=script&lang=js&"
import style0 from "./leifeng_health_suggestion.vue?vue&type=style&index=0&id=e8c1ddb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c1ddb4",
  null
  
)

export default component.exports